import { defineStore } from 'pinia';
import { ref } from 'vue';

const useSidebarStore = defineStore('sidebar', () => {
  const isVisible = ref(false);

  const toggle = (): void => {
    isVisible.value = !isVisible.value;
  };

  const toggleValue = (val: boolean): void => {
    isVisible.value = val;
  };

  return { isVisible, toggle, toggleValue };
});

export default useSidebarStore;
